import { Box, Chip } from '@mui/material';
import { WD } from '../../../warningDashboard/warningTheme';
import { LEVEL_TONE, LOAD_LEVELS, LOAD_ORDER } from '../utils/constants';

/** "All 13 · Overloaded 2 · …" - filters the person table to one load level. Only levels somebody is at are offered. */
export default function LevelFilterChips({ summary, value, onChange }) {
  const chips = [
    { key: 'all', label: 'All', count: summary.rows.length },
    ...LOAD_ORDER.filter((key) => summary.levels[key] > 0).map((key) => ({ key, label: LOAD_LEVELS[key].label, count: summary.levels[key] })),
  ];

  return (
    <Box display="flex" flexWrap="wrap" gap={0.75} role="group" aria-label="Filter by load level">
      {chips.map((chip) => {
        const on = chip.key === value;
        const tone = LEVEL_TONE[chip.key];
        return (
          <Chip
            key={chip.key}
            size="small"
            label={`${chip.label} ${chip.count}`}
            aria-pressed={on}
            onClick={() => onChange(chip.key)}
            variant={on ? 'filled' : 'outlined'}
            sx={{
              borderColor: on && tone ? tone.accent : WD.border,
              bgcolor: on ? (tone ? tone.bg : WD.greenTint) : 'transparent',
              color: on ? (tone ? tone.text : WD.green) : WD.inkMuted,
            }}
          />
        );
      })}
    </Box>
  );
}
